"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var NewCardForm = /** @class */ (function () {
    function NewCardForm() {
    }
    return NewCardForm;
}());
exports.default = NewCardForm;
//# sourceMappingURL=NewCardForm.js.map